import Api from '../api'
import Firebase from './firebase'
import Storage from '@/helpers/storage'
import IndexedDb from './indexedDb'
import ENUM from '@/assets/ENUM'

export default {

    isRegister: false,
    fToken: '',

    permission() {
        return Notification.permission
    },
    
    isGranted() {
        return Notification.permission === ENUM.NOTIFICATIONS.GRANTED
    },
    
    isDenied() {
        return Notification.permission === ENUM.NOTIFICATIONS.DENIED
    },

    isDefault() {
        return Notification.permission === ENUM.NOTIFICATIONS.DEFAULT
    },

    requestPermission() {
        return Notification.requestPermission()
    },

    update(options) {
        IndexedDb.saveLang()
        return this.checkPermission()
            .then(() => this.checkToken())
            .then(fToken => this.checkRegister(fToken))
            .then(() => Api.notifications.update(options))
    },

    register() {
        return this.firebaseGetToken()
            .then(fToken => Api.notifications.register(fToken, this.getUniqueKey()))
    },

    unregister() {
        return this.firebaseGetToken()
            .then(() => this.update({important: false, news: false}))
            .then(() => this.isRegister = false)
    },

    /** private **/

    async checkPermission() {
        switch (Notification.permission) {
            case 'granted':
                break
            case 'default':
                return Notification.requestPermission()
                    .catch(() => {
                        throw new Error('denied')
                    })
            default:
                throw new Error('denied')
        }
    },

    async checkToken() {
        if (this.fToken.length) {
            return this.fToken
        }

        return await this.firebaseGetToken()
            .catch(() => {
                throw new Error('token__error')
            })
    },

    firebaseGetToken() {
        this.fToken = Firebase.messagingToken
        return Promise.resolve(this.fToken)
    },

    async checkRegister(token) {
        if (!this.isRegister) {
            return Api.notifications.register(token, this.getUniqueKey())
                .then(() => this.isRegister = true)
                .catch(() => {
                    throw new Error('register_error')
                })
        }
    },

    getUniqueKey() {
        const key = Storage.getItem('firebaseAppInstanceId')

        if (key) {
            return key
        }

        const uniqKey = new Date().getTime().toString(16)

        Storage.setItem('firebaseAppInstanceId', uniqKey)

        return uniqKey
    },

    haveNotificationsNeverBeenRequested() {
        return this.permission() !== 'denied' && !Storage.getItem('firebaseAppInstanceId')
    }
}
